<template>
	<v-flex>
		<v-text-field
			@focus="focusAction"
			:prepend-icon="$props.prependicon"
			:counter="$props.counter"
			:maxLength="lengthComputed"
			:error-messages="$props.error"
			:hint="$props.hint"
			:label="$props.label"
			:mask="$props.mask"
			:placeholder="' '"
			:readonly="$props.readonly"
			:rules="$props.rules"
			:type="$props.type"
			v-if="!isSimple"
			v-model="inputValue"></v-text-field>
		<v-text-field
			@focus="focusAction"
			:prepend-icon="$props.prependicon"
			:counter="$props.counter"
			:maxLength="lengthComputed"
			:mask="$props.mask"
			:placeholder="$props.placeholder"
			:readonly="$props.readonly"
			:rules="$props.rules"
			:type="$props.type"
			class="simple" hide-details
			v-if="isSimple"
			v-model="inputValue"></v-text-field>
	</v-flex>
</template>

<script>
	export default {
		name: "InputField",
		props: ['rules', 'readonly', 'simple', 'value', 'error', 'placeholder', 'label', 'type', 'mask', 'hint', 'counter', 'prependicon', 'maxlength'],
		data() {
			return {
				inputValue: this.$props.value
			}
		},
		computed: {
			isSimple() {
				return ((typeof this.$props.simple !== 'undefined') && (this.$props.simple !== false));
			},
			lengthComputed() {
				let length = undefined;
				if (typeof this.$props.maxlength !== 'undefined') {
					length = this.$props.maxlength;
				}
				if (typeof this.$props.counter !== 'undefined') {
					length = this.$props.counter;
				}
				return length
			}
		},
		watch: {
			inputValue() {
				this.$emit('input', this.inputValue);
			},
			value() {
				this.inputValue = this.$props.value;
			}
		},
		methods: {
			focusAction() {
				this.$emit('focus');
			}
		}
	}
</script>

<style scoped>
	.simple {
		padding: 0px;
		margin: 0px;
	}
</style>
